import React, { useState } from 'react';
import './Navbar.css';
import { NavLink } from 'react-router-dom';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav 
      className="navbar navbar-expand-lg glass-navbar border-bottom border-body p-2 text-center shadow-lg sticky-top" 
      data-bs-theme="dark" 
      data-aos="fade-down" 
      data-aos-duration="1000" 
      data-aos-once="true"
      style={{ zIndex: 1050 }}
    >
      <div className="container-fluid flex-column align-items-start">
        <div className="row justify-content-center align-items-center w-100 mt-3">
          <div className="col-12 d-flex flex-column align-items-end">
            
            {/* Mobile Toggle Button with React onClick */}
            <button 
              className="navbar-toggler mb-2" 
              type="button" 
              onClick={() => setIsOpen(!isOpen)}
              aria-expanded={isOpen} 
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            {/* Conditionally attach 'show' via React state */}
            <div 
              className={`collapse navbar-collapse justify-content-center w-100 ${isOpen ? 'show' : ''}`} 
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav justify-content-center mb-2 mb-lg-0 text-center w-100 fs-6">
                
                <li className="nav-item px-2">
                  <NavLink 
                    to="/" 
                    onClick={() => setIsOpen(false)}
                    className={({ isActive }) => "bi bi-house nav-link text-light text-decoration-none hover-underline-animation" + (isActive ? " active" : "")}
                  >
                    {" "}Home
                  </NavLink>
                </li>

                <li className="nav-item dropdown px-2">
                  <NavLink 
                    to="/AboutMe" 
                    className={({ isActive }) => "bi bi-person-fill nav-link text-light text-decoration-none hover-underline-animation" + (isActive ? " active" : "")} 
                    role="button" 
                    data-bs-toggle="dropdown" 
                    aria-expanded="false"
                  >
                    {" "}About Me
                  </NavLink>
                  <ul className="dropdown-menu text-center text-lg-start">
                    <li><NavLink to="/AboutMe/AdministrativeResponsibilities" onClick={() => setIsOpen(false)} className="d-block text-light text-decoration-none mx-4 pt-2 text-nowrap hover-underline-animation">Administrative Responsibilities</NavLink></li>
                    <li><NavLink to="/AboutMe/BioSketch" onClick={() => setIsOpen(false)} className="d-block text-light text-decoration-none mx-4 pt-2 text-nowrap hover-underline-animation">Bio-Sketch</NavLink></li>
                    <li><NavLink to="/AboutMe/IndustryExperience" onClick={() => setIsOpen(false)} className="d-block text-light text-decoration-none mx-4 py-2 text-nowrap hover-underline-animation">Industry Experience</NavLink></li>
                  </ul>
                </li>

                <li className="nav-item px-2">
                  <NavLink 
                    to="/AwardsAndHonours" 
                    onClick={() => setIsOpen(false)}
                    className={({ isActive }) => "bi bi-award nav-link text-light text-decoration-none hover-underline-animation" + (isActive ? " active" : "")}
                  >
                    {" "}Awards And Honours
                  </NavLink>
                </li>

                <li className="nav-item dropdown px-2">
                  <NavLink 
                    to="/Consulting-Projects-MDPs" 
                    className={({ isActive }) => "bi bi-cast nav-link text-light text-decoration-none hover-underline-animation" + (isActive ? " active" : "")} 
                    role="button" 
                    data-bs-toggle="dropdown" 
                    aria-expanded="false"
                  >
                    {" "}Consulting/Projects/MDPs
                  </NavLink>
                  <ul className="dropdown-menu text-center text-lg-start">
                    <li><NavLink to="/Consulting-Projects-MDPs/Grants–ResearchProjects-Consulting" onClick={() => setIsOpen(false)} className="d-block text-light text-decoration-none mx-4 pt-2 text-nowrap hover-underline-animation">Grants – Research Projects/Consulting</NavLink></li>
                    <li><NavLink to="/Consulting-Projects-MDPs/MDPs" onClick={() => setIsOpen(false)} className="d-block text-light text-decoration-none mx-4 pt-2 text-nowrap hover-underline-animation">MDPs</NavLink></li>
                  </ul>
                </li>

                <li className="nav-item px-2">
                  <NavLink 
                    to="/DoctoralSection" 
                    onClick={() => setIsOpen(false)}
                    className={({ isActive }) => "bi bi-clipboard-check-fill nav-link text-light text-decoration-none hover-underline-animation" + (isActive ? " active" : "")}
                  >
                    {" "}Doctoral Section
                  </NavLink>
                </li>

                <li className="nav-item dropdown px-2">
                  <NavLink 
                    to="/Research" 
                    className={({ isActive }) => "bi bi-book nav-link text-light text-decoration-none hover-underline-animation" + (isActive ? " active" : "")} 
                    role="button" 
                    data-bs-toggle="dropdown" 
                    aria-expanded="false"
                  >
                    {" "}Research
                  </NavLink>
                  <ul className="dropdown-menu text-center text-lg-start">
                    <li><NavLink to="/Research/Books" onClick={() => setIsOpen(false)} className="d-block text-light text-decoration-none mx-4 pt-2 text-nowrap hover-underline-animation">Books</NavLink></li>
                    <li><NavLink to="/Research/CaseStudies" onClick={() => setIsOpen(false)} className="d-block text-light text-decoration-none mx-4 pt-2 text-nowrap hover-underline-animation">Case Studies</NavLink></li>
                    <li><NavLink to="/Research/Conferences" onClick={() => setIsOpen(false)} className="d-block text-light text-decoration-none mx-4 py-2 text-nowrap hover-underline-animation">Conferences</NavLink></li>
                    <li><NavLink to="/Research/DoctoralScholars" onClick={() => setIsOpen(false)} className="d-block text-light text-decoration-none mx-4 pt-2 text-nowrap hover-underline-animation">Doctoral Scholars</NavLink></li>
                    <li><NavLink to="/Research/Patents" onClick={() => setIsOpen(false)} className="d-block text-light text-decoration-none mx-4 pt-2 text-nowrap hover-underline-animation">Patents</NavLink></li>
                    <li><NavLink to="/Research/JournalPublications-BookChapters" onClick={() => setIsOpen(false)} className="d-block text-light text-decoration-none mx-4 py-2 text-nowrap hover-underline-animation">Journal Publications/Book Chapters</NavLink></li>
                  </ul>
                </li>

                <li className="nav-item dropdown px-2">
                  <NavLink 
                    to="/Teaching" 
                    className={({ isActive }) => "bi bi-mortarboard-fill nav-link text-light text-decoration-none hover-underline-animation" + (isActive ? " active" : "")} 
                    role="button" 
                    data-bs-toggle="dropdown" 
                    aria-expanded="false"
                  >
                    {" "}Teaching
                  </NavLink>
                  <ul className="dropdown-menu text-center text-lg-start">
                    <li><NavLink to="/Teaching/CoursesTaught" onClick={() => setIsOpen(false)} className="d-block text-light text-decoration-none mx-4 pt-2 text-nowrap hover-underline-animation">Courses Taught</NavLink></li>
                  </ul>
                </li>

                <li className="nav-item px-2">
                  <NavLink 
                    to="/Workshops" 
                    onClick={() => setIsOpen(false)}
                    className={({ isActive }) => "bi bi-wrench nav-link text-light text-decoration-none hover-underline-animation" + (isActive ? " active" : "")}
                  >
                    {" "}Workshops
                  </NavLink>
                </li>

                <li className="nav-item px-2">
                  <NavLink 
                    to="/Contact" 
                    onClick={() => setIsOpen(false)}
                    className={({ isActive }) => "bi bi-telephone-fill nav-link text-light text-decoration-none hover-underline-animation" + (isActive ? " active" : "")}
                  >
                    {" "}Contact
                  </NavLink>
                </li>

                <li className="nav-item px-2">
                  <NavLink 
                    to="/AskMe" 
                    onClick={() => setIsOpen(false)}
                    className={({ isActive }) => "bi bi-question-lg nav-link text-light text-decoration-none hover-underline-animation" + (isActive ? " active" : "")}
                  >
                    {" "}Ask Me
                  </NavLink>
                </li>

              </ul>
            </div>

          </div>
        </div>
      </div>
    </nav>
  );
}